import React, { useState } from 'react';
import './Kalkulator.css';

export default function VATCalculator() {
  const [amount, setAmount] = useState('');
  const [vatRate, setVatRate] = useState(17);
  const [mode, setMode] = useState('netToGross');

  const parsedAmount = parseFloat(amount) || 0;
  const parsedRate = parseFloat(vatRate) || 0;

  let net, vat, gross;
  if (mode === 'netToGross') {
    net = parsedAmount;
    vat = net * (parsedRate / 100);
    gross = net + vat;
  } else {
    gross = parsedAmount;
    net = gross / (1 + parsedRate / 100);
    vat = gross - net;
  }

  const clearFields = () => {
    setAmount('');
    setVatRate(17);
    setMode('netToGross');
  };

  return (
    <div className="container">
      {/* Form section */}
      <div className="form-container">
        <div className="card">
          <div className="form-header">
            <h2>PDV Kalkulator</h2>
            <button className="clear-button" onClick={clearFields}>
              Očisti
            </button>
          </div>

          <div className="field-group">
            <label className="field-label">Tip izračuna:</label>
            <select
              className="field-select"
              value={mode}
              onChange={(e) => setMode(e.target.value)}
            >
              <option value="netToGross">Osnovica → Bruto</option>
              <option value="grossToNet">Bruto → Osnovica</option>
            </select>
          </div>

          <div className="field-group">
            <label className="field-label">
              {mode === 'netToGross' ? 'Osnovica:' : 'Bruto iznos:'}
            </label>
            <input
              type="number"
              className="field-input"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="0.00"
            />
          </div>

          <div className="field-group">
            <label className="field-label">Stopa PDV (%) :</label>
            <input
              type="number"
              className="field-input"
              value={vatRate}
              onChange={(e) => setVatRate(e.target.value)}
              placeholder="npr. 17"
            />
          </div>
        </div>
      </div>

      {/* Results section */}
      <div className="results-container">
        <div className="card results-section">
          <h3 className="subsection-title">Rezultati</h3>
          <div className="result-row">
            <span>Osnovica:</span>
            <span>{net.toFixed(2)}</span>
          </div>
          <div className="result-row">
            <span>PDV:</span>
            <span>{vat.toFixed(2)}</span>
          </div>
          <div className="result-row">
            <span>Ukupno:</span>
            <span>{gross.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
